// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/cross-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Images/down-arrow-white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-two-fa-txn > .OtpInputBox > input {
  width: 40px !important;
  height: 40px !important;
  text-align: center;
  margin-right: 8px !important;
  border-radius: 7px;
  border: 1px solid black;
}

.crypto-send .nav-link {
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
  font-style: normal;
  font-weight: 600;
  outline: none;
  color: #6f7182;
}

.crypto-send .nav-item .active {
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  color: #1476ff;
  outline: none;
}

.wallet-page .currencytab {
  display: flex;
  align-items: center;
  border: 2px solid #1476ff;
  background: transparent;
  font-style: normal;
  font-weight: 600;
  outline: none;
  font-size: 13px;
  border-radius: 20px;
  color: black;
  outline: none;
}

.wallet-page .currencytab.nav-link.active {
  display: flex;
  font-size: 13px;
  align-items: center;
  background: #1476ff;
  font-style: normal;
  outline: none;
  font-weight: 600;
  border-radius: 20px;
  border: 1px solid #1476ff;
  color: #ffffff;
  outline: none;
}

.loadbutton {
  border: none;
  font-size: 16px;
  border-bottom: 1px solid grey;
  font-weight: 500;
  background: transparent;
  outline: none;
}

.navline {
  border-bottom: 1px solid lightslategray !important;
}

.btn-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  color: black;
  opacity: 1;
}

.btn-close:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.table-container {
  width: 100% !important;
  overflow-x: scroll;
  /* border-top-left-radius: 30px; */
  padding: 0px;
  /* border-top-right-radius: 30px; */
  box-shadow: 0px 0px 15px #e9eaf3;
}

.selectCurrency {
  border: none;
}

.loadfiatcard {
  width: 150px;
  margin: 9px 0px;
}

.Table {
  width: 100%;
  background: rgb(167, 213, 252);
  background: linear-gradient(
    58deg,
    rgba(167, 213, 252, 1) 0%,
    rgba(203, 255, 252, 1) 59%,
    rgba(170, 251, 206, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#a7d5fc", endColorstr="#aafbce", GradientType=1);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.mywallettable {
  border-radius: 0px !important;
  margin-bottom: 25px;
}

.transaction-table {
  box-shadow: 0px 0px 15px #e9eaf3;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.multi-collapse {
  margin: 2px 10px;
  padding: 0px 10px;
}

.accordion-item {
  background: transparent;
  border: none;
  outline: none;
}

.accordion-button {
  border: 1px solid #e9eaf3;
  border-radius: 30px;
  margin-top: 10px;
  font-weight: 500;
  padding: 10px 16px;
  color: black;
}

.dark .accordion-button {
  background: transparent;
  color: #ffffff;
  border: 1px solid white !important;
}

.accordion-button:focus {
  background: #1476ff !important;
  color: #ffffff !important;
  font-weight: 500 !important;
}

.dark .accordion-button:not(.collapsed) {
  background: black;
  color: #ffffff;
  font-weight: 500;
}

.accordion-button:not(.collapsed) {
  color: black;
  background: white;
  border: 1px solid #e9eaf3;
}

.Button {
  border: none;
  background-color: #1476ff;
  color: white;
  text-align: center;
  width: 100%;
  margin-top: 20px;
  padding: 12px 22px;
  border-radius: 45px;
}

.modal {
  border-radius: 20px;
}

.accordion-button:focus {
  border: 1px solid #e9eaf3 !important;
  box-shadow: none !important;
  background-color: #1476ff !important;
  color: black;
}

.dark .accordion-button::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  transform: translateY(5px) !important;
}

.dark .accordion-button:not(.collapsed)::after {
  transform: rotate(0deg) translateY(5px) !important;
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 30px !important;
  border-top-right-radius: 30px !important;
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
}

.dropdown-menu {
  min-width: 6.7rem;
}

.convertTitle {
  color: #0b0e2c;
  font-weight: 500;
  font-size: 24px;
}

.convertTitle span {
  font-weight: 700;
}
.convert-para {
  font-size: 14px;
  font-weight: 400;
}
.input-dev {
  width: 75%;
  margin: 0 auto;
}

.fontSize {
  font-size: 14px;
}

.select-token-option {
  box-shadow: 0px 0px 10px #e9eaf3;
  border-radius: 52px;
  border: 1px solid #e9eaf3;
}
.select-token-option > div > div {
  border: unset;
  box-shadow: unset;
  border-radius: unset;
}

.selectedTokenIconNname > span {
  color: #0b0e2c;
  font-size: 14px;
  font-weight: 500;
}
.selectedTokenIconNname > img {
  width: 23px;
  height: 23px;
}

.selectCurrency > div > div > div.css-1dimb5e-singleValue {
  font-size: 12px;
  color: #1476ff;
  font-weight: 400;
}

.group_button > button {
  background-color: #1476ff;
  border-radius: 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 20px;
  outline: unset;
  border: unset;
}
.group_button > button:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.min_amoutn {
  font-size: 10px;
  font-weight: 400;
  padding: 2px 5px;
  border-radius: 3px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0;
  border: 1px solid #666666;
}

button.nav-li-link.active {
  color: rgb(20, 118, 255) !important;
}

.add_class > div:first-child > div:first-child>div:first-child> div:first-child{
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

.oval_loader{
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
}

.warning_text{
  font-size: 12px;
  font-weight: 400;
}

.resetOTPBTN{
  border: none;
  outline: unset;
  background-color: transparent;
  color: #1476ff;
  font-size: 14px;
  font-weight: 500;
  margin: 0 auto;
}

@media screen and (max-width: 576px) {
  .input-dev {
    width: 100%;
  }
  .selectCurrency {
    width: 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Wallet/Wallet.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mDAA8C;EAC9C,4BAA4B;EAC5B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAa9B;;;;;GAKC;EACD,kHAAkH;EAClH,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,yDAA+D;EAC/D,qCAAqC;AACvC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".verify-two-fa-txn > .OtpInputBox > input {\n  width: 40px !important;\n  height: 40px !important;\n  text-align: center;\n  margin-right: 8px !important;\n  border-radius: 7px;\n  border: 1px solid black;\n}\n\n.crypto-send .nav-link {\n  display: flex;\n  align-items: center;\n  border: none;\n  background: transparent;\n  font-style: normal;\n  font-weight: 600;\n  outline: none;\n  color: #6f7182;\n}\n\n.crypto-send .nav-item .active {\n  display: flex;\n  align-items: center;\n  background: transparent;\n  border: none;\n  color: #1476ff;\n  outline: none;\n}\n\n.wallet-page .currencytab {\n  display: flex;\n  align-items: center;\n  border: 2px solid #1476ff;\n  background: transparent;\n  font-style: normal;\n  font-weight: 600;\n  outline: none;\n  font-size: 13px;\n  border-radius: 20px;\n  color: black;\n  outline: none;\n}\n\n.wallet-page .currencytab.nav-link.active {\n  display: flex;\n  font-size: 13px;\n  align-items: center;\n  background: #1476ff;\n  font-style: normal;\n  outline: none;\n  font-weight: 600;\n  border-radius: 20px;\n  border: 1px solid #1476ff;\n  color: #ffffff;\n  outline: none;\n}\n\n.loadbutton {\n  border: none;\n  font-size: 16px;\n  border-bottom: 1px solid grey;\n  font-weight: 500;\n  background: transparent;\n  outline: none;\n}\n\n.navline {\n  border-bottom: 1px solid lightslategray !important;\n}\n\n.btn-close {\n  background: url(\"../../assets/cross-logo.svg\");\n  background-repeat: no-repeat;\n  color: black;\n  opacity: 1;\n}\n\n.btn-close:focus {\n  outline: none;\n  border: none;\n  box-shadow: none;\n}\n\n.table-container {\n  width: 100% !important;\n  overflow-x: scroll;\n  /* border-top-left-radius: 30px; */\n  padding: 0px;\n  /* border-top-right-radius: 30px; */\n  box-shadow: 0px 0px 15px #e9eaf3;\n}\n\n.selectCurrency {\n  border: none;\n}\n\n.loadfiatcard {\n  width: 150px;\n  margin: 9px 0px;\n}\n\n.Table {\n  width: 100%;\n  background: rgb(167, 213, 252);\n  background: -moz-linear-gradient(\n    58deg,\n    rgba(167, 213, 252, 1) 0%,\n    rgba(203, 255, 252, 1) 59%,\n    rgba(170, 251, 206, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    58deg,\n    rgba(167, 213, 252, 1) 0%,\n    rgba(203, 255, 252, 1) 59%,\n    rgba(170, 251, 206, 1) 100%\n  );\n  background: linear-gradient(\n    58deg,\n    rgba(167, 213, 252, 1) 0%,\n    rgba(203, 255, 252, 1) 59%,\n    rgba(170, 251, 206, 1) 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#a7d5fc\", endColorstr=\"#aafbce\", GradientType=1);\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\n.mywallettable {\n  border-radius: 0px !important;\n  margin-bottom: 25px;\n}\n\n.transaction-table {\n  box-shadow: 0px 0px 15px #e9eaf3;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\n.multi-collapse {\n  margin: 2px 10px;\n  padding: 0px 10px;\n}\n\n.accordion-item {\n  background: transparent;\n  border: none;\n  outline: none;\n}\n\n.accordion-button {\n  border: 1px solid #e9eaf3;\n  border-radius: 30px;\n  margin-top: 10px;\n  font-weight: 500;\n  padding: 10px 16px;\n  color: black;\n}\n\n.dark .accordion-button {\n  background: transparent;\n  color: #ffffff;\n  border: 1px solid white !important;\n}\n\n.accordion-button:focus {\n  background: #1476ff !important;\n  color: #ffffff !important;\n  font-weight: 500 !important;\n}\n\n.dark .accordion-button:not(.collapsed) {\n  background: black;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.accordion-button:not(.collapsed) {\n  color: black;\n  background: white;\n  border: 1px solid #e9eaf3;\n}\n\n.Button {\n  border: none;\n  background-color: #1476ff;\n  color: white;\n  text-align: center;\n  width: 100%;\n  margin-top: 20px;\n  padding: 12px 22px;\n  border-radius: 45px;\n}\n\n.modal {\n  border-radius: 20px;\n}\n\n.accordion-button:focus {\n  border: 1px solid #e9eaf3 !important;\n  box-shadow: none !important;\n  background-color: #1476ff !important;\n  color: black;\n}\n\n.dark .accordion-button::after {\n  background-image: url(../../assets/Images/down-arrow-white.svg);\n  transform: translateY(5px) !important;\n}\n\n.dark .accordion-button:not(.collapsed)::after {\n  transform: rotate(0deg) translateY(5px) !important;\n}\n\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: 30px !important;\n  border-top-right-radius: 30px !important;\n}\n\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: 30px !important;\n  border-bottom-left-radius: 30px !important;\n}\n\n.dropdown-menu {\n  min-width: 6.7rem;\n}\n\n.convertTitle {\n  color: #0b0e2c;\n  font-weight: 500;\n  font-size: 24px;\n}\n\n.convertTitle span {\n  font-weight: 700;\n}\n.convert-para {\n  font-size: 14px;\n  font-weight: 400;\n}\n.input-dev {\n  width: 75%;\n  margin: 0 auto;\n}\n\n.fontSize {\n  font-size: 14px;\n}\n\n.select-token-option {\n  box-shadow: 0px 0px 10px #e9eaf3;\n  border-radius: 52px;\n  border: 1px solid #e9eaf3;\n}\n.select-token-option > div > div {\n  border: unset;\n  box-shadow: unset;\n  border-radius: unset;\n}\n\n.selectedTokenIconNname > span {\n  color: #0b0e2c;\n  font-size: 14px;\n  font-weight: 500;\n}\n.selectedTokenIconNname > img {\n  width: 23px;\n  height: 23px;\n}\n\n.selectCurrency > div > div > div.css-1dimb5e-singleValue {\n  font-size: 12px;\n  color: #1476ff;\n  font-weight: 400;\n}\n\n.group_button > button {\n  background-color: #1476ff;\n  border-radius: 20px;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 6px 20px;\n  outline: unset;\n  border: unset;\n}\n.group_button > button:hover {\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n.min_amoutn {\n  font-size: 10px;\n  font-weight: 400;\n  padding: 2px 5px;\n  border-radius: 3px;\n  width: fit-content;\n  margin: 0;\n  border: 1px solid #666666;\n}\n\nbutton.nav-li-link.active {\n  color: rgb(20, 118, 255) !important;\n}\n\n.add_class > div:first-child > div:first-child>div:first-child> div:first-child{\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n}\n\n.oval_loader{\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 10;\n}\n\n.warning_text{\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.resetOTPBTN{\n  border: none;\n  outline: unset;\n  background-color: transparent;\n  color: #1476ff;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 auto;\n}\n\n@media screen and (max-width: 576px) {\n  .input-dev {\n    width: 100%;\n  }\n  .selectCurrency {\n    width: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
